import getters from './leadGenGetters'
import actions from './leadGenActions'
import mutations from './leadGenMutations'

// Simple session storage key
const STORAGE_KEY = 'leadGenFlow'

// Simple function to load state
const loadFromStorage = () => {
  try {
    const data = sessionStorage.getItem(STORAGE_KEY)
    return data ? JSON.parse(data) : null
  } catch (error) {
    console.error('Failed to load from session storage:', error)
    return null
  }
}

// Load saved data
const savedData = loadFromStorage()

const store = {
  namespaced: true,
  state: () => ({
    leadGenQuestions: savedData?.leadGenQuestions || [],
    answers: savedData?.answers || {},
    questionFlowData: {},
    orgGuid: savedData?.orgGuid || null,
    orgId: null,
    orgType: savedData?.orgType || null,
    settings: savedData?.settings || {
      landingPageTitle: null,
      name: null,
      orgIcon: null,
      orgAppIcon: null,
      servicerImageUrl: null,
      servicerInitials: null,
      partnerImageUrl: null,
      partnerInitials: null
    },
    currentQuestionIndex: savedData?.currentQuestionIndex || 0,
    formSubmitted: false,
    sac: savedData?.sac || null,
    previewForm: false,
    previewQuestion: false
  }),
  getters,
  actions,
  mutations
}

export default store
